'use client';

import { cn } from '@/lib/utils';
import { useLanguage } from '@/providers/i18n-provider';

/**
 * EN/DE language pill — flag plus mono label, echoes the homepage tone.
 * Shared by the guest header (HeaderTopbar) and the signed-in shell's top bar
 * (AppTopBar).
 *
 * `stable` keeps it shown at every width (the header's fit probe needs a
 * width that does not change at breakpoints, see header-topbar.tsx); without
 * it the pill hides below lg, where the toggle lives in the mobile menu.
 */
export function LanguageToggle({ stable = false }: { stable?: boolean }) {
  const { languageCode, changeLanguage } = useLanguage();

  return (
    <button
      type="button"
      onClick={() => changeLanguage(languageCode === 'en' ? 'de' : 'en')}
      className={cn(
        'items-center rounded-full border h-9 transition-colors',
        stable
          ? 'inline-flex gap-2 px-3'
          : 'hidden lg:inline-flex gap-1.5 lg:gap-2 px-2.5 lg:px-3',
      )}
      style={{
        borderColor: 'var(--fd-line-2)',
        background: 'transparent',
        color: 'var(--fd-ink-2)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'var(--fd-bg-2)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'transparent';
      }}
      aria-label={
        languageCode === 'en' ? 'Switch to German' : 'Zu Englisch wechseln'
      }
    >
      <img
        src={
          languageCode === 'en'
            ? '/media/flags/united-kingdom.svg'
            : '/media/flags/germany.svg'
        }
        alt=""
        className="w-5 h-3.5 rounded-[2px] object-cover"
      />
      <span className="fd-mono text-[16px] font-medium tracking-[0.04em]">
        {languageCode === 'en' ? 'EN' : 'DE'}
      </span>
    </button>
  );
}
